import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { MenuItem, Modal, Select, Typography } from '@material-ui/core';
import CustomTooltip from '../../../components/CustomTooltip';
import { InfoOutlined } from '@material-ui/icons';
import ActionButton from '../../../components/ActionButton';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContainer: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    alignItems: 'center',
    gap: '30px',
    backgroundColor: 'white',
    color: 'black',
    padding: '30px',
    borderRadius: '6px',
    boxShadow: theme.shadows[6],
    overflowY: 'auto',
    width: '60%',
    maxWidth: '840px',
    [theme.breakpoints.down('md')]: {
      width: '90%',
    },
  },
  selectWrapper: {
    display: 'flex',
    gap: '10px',
    alignItems: 'center',
    width: '50%',
    textAlign: 'center',
  },
}));

const ControlloSemplificatoModal = ({ onClose, open, updateModalita }) => {
  const classes = useStyles();

  const [modalitaControllo, setModalitaControllo] = useState(false);

  return (
    <Modal
      open={open}
      onClose={onClose}
      className={classes.modal}
      BackdropProps={{
        onClick: (e) => e.stopPropagation(),
      }}
    >
      <div className={classes.modalContainer}>
        <Typography variant="h5">
          Selezionare la modalità di gestione dei controlli di non conformità
        </Typography>
        <div className={classes.selectWrapper}>
          <Select
            fullWidth
            variant="outlined"
            value={modalitaControllo}
            onChange={(e) => setModalitaControllo(e.target.value)}
          >
            <MenuItem value={false}>Normale</MenuItem>
            <MenuItem value={true}>Semplificata</MenuItem>
          </Select>
          <CustomTooltip
            title={
              <>
                <Typography variant="caption">
                  <b>Modalità normale:</b> i controlli saranno dotati di limiti,
                  cause e azioni correttive.
                </Typography>
                <br />
                <Typography variant="caption">
                  <b>Modalità semplificata:</b> i controlli avranno solo azioni
                  correttive.
                </Typography>
              </>
            }
            arrow
            placement="right"
          >
            <InfoOutlined fontSize="small" color="secondary" />
          </CustomTooltip>
        </div>

        <ActionButton
          label="Conferma"
          onClick={() => updateModalita(Boolean(modalitaControllo))}
        />
      </div>
    </Modal>
  );
};

ControlloSemplificatoModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  updateModalita: PropTypes.func.isRequired,
};

export default ControlloSemplificatoModal;
